import { useCallback, useState } from 'react';
import { type InfoBlockStorageKey, persistentStorage } from '../storage';

export const useInfoBlock = (name: InfoBlockStorageKey) => {
    const [isClosed, setIsClosed] = useState(persistentStorage.getItem(name) === '1');

    const close = useCallback(() => {
        persistentStorage.setItem(name, '1');
        setIsClosed(true);
    }, [name]);

    return { isClosed, close };
};
